'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var catalogSortOrders = {
    /*eslint-disable */
    DATE_ASCENDING: 'DATE_ASCENDING',
    DATE_DESCENDING: 'DATE_DESCENDING'
    /*eslint-enable */
};

exports.default = catalogSortOrders;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/enums/catalogSortOrders.js
// module id = pBUe
// module chunks = 57